"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertModuleTabsToNavItems = void 0;
const react_1 = __importDefault(require("react"));
const react_router_dom_1 = require("react-router-dom");
const IdleTimeout_1 = require("./IdleTimeout");
const NavWrapper_1 = require("./NavWrapper");
const NoContent = () => null;
const convertModuleTabsToNavItems = (modules, pathname) => modules.map(({ title, expectedPath, guard }) => ({
    link: react_1.default.createElement(react_router_dom_1.Link, { to: expectedPath }, title),
    active: pathname.includes(expectedPath),
    privilege: guard || true,
    name: title,
    url: expectedPath,
}));
exports.convertModuleTabsToNavItems = convertModuleTabsToNavItems;
function PrivateRoute({ children, authenticated, url, logout, path, name, modules, ...props }) {
    const Content = (componentProps) => (react_1.default.createElement(NavWrapper_1.NavWrapper, { ...props, ...componentProps, logout: logout, primaryNavName: name, navItems: (0, exports.convertModuleTabsToNavItems)(modules, path) },
        react_1.default.createElement(IdleTimeout_1.IdleTimeout, { logout: logout }),
        children));
    return react_1.default.createElement(react_router_dom_1.Route, { path: path, render: authenticated ? Content : NoContent });
}
exports.default = PrivateRoute;
